import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import * as S from './Navbar.styles';
import { CDN_BASE_URL } from '../../config';

const logoSrc = CDN_BASE_URL + '/static/logo.png';

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const handleToggle = () => setOpen((prev) => !prev);
  const handleClose = () => setOpen(false);

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      <S.Nav>
        <S.Logo src={logoSrc} alt="Uplus Education" />
        <S.NavLinks open={open}>
          <Link to="/" onClick={handleClose} className={isActive('/') ? 'active' : ''}>
            Home
          </Link>
          <Link to="/courses" onClick={handleClose} className={isActive('/courses') ? 'active' : ''}>
            Courses
          </Link>
          <Link to="/team" onClick={handleClose} className={isActive('/team') ? 'active' : ''}>
            Team
          </Link>
          <Link to="/timetable" onClick={handleClose} className={isActive('/timetable') ? 'active' : ''}>
            Timetable
          </Link>
          <Link to="/careers" onClick={handleClose} className={isActive('/careers') ? 'active' : ''}>
            Careers
          </Link>
<Link to="/contact" onClick={handleClose} className={isActive('/contact') ? 'active' : ''}>
            Contact
          </Link>
          <Link to="/official-resources" onClick={handleClose} className={isActive('/official-resources') ? 'active' : ''}>
            Resources
          </Link>
          <S.MobileButtonGroup>
            <S.AssessmentButton
              to="/assessment"
              onClick={handleClose}
              style={{ marginLeft: 0 }}
            >
              Book a Free Assessment
            </S.AssessmentButton>
            <S.LoginButton to="/login" onClick={handleClose}>
              Login
            </S.LoginButton>
          </S.MobileButtonGroup>
        </S.NavLinks>
        <S.DesktopButtonGroup>
          <S.AssessmentButton
            to="/assessment"
            onClick={handleClose}
            style={{ marginLeft: 0 }}
          >
            Book a Free Assessment
          </S.AssessmentButton>
          <S.LoginButton to="/login" onClick={handleClose}>
            Login
          </S.LoginButton>
        </S.DesktopButtonGroup>
        <S.HamburgerIcon open={open} onClick={handleToggle}>
          <span></span>
          <span></span>
          <span></span>
        </S.HamburgerIcon>
      </S.Nav>
      <S.Overlay open={open} onClick={handleClose} />
    </>
  );
};

export default Navbar;